









import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GColorPreview',
  props: {
    color: { type: String as PropType<string>, default: '' },
  },
});
